// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Icon_arrow__1R_AT","active-up":"Icon_active-up__18uXJ","active-down":"Icon_active-down__2B5St","disabled":"Icon_disabled__1qOMp"};